interface IconProps {
  width?: number;
  height?: number;
  fill?: string;
  stroke?: string;
  strokeWidth?: number;
  opacity?: number;
  className?: string;
}

export function PlusIcon({
  width = 20,
  height = 20,
  fill = 'currentColor',
  className,
}: IconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M11 13H6C5.71667 13 5.47917 12.9042 5.2875 12.7125C5.09583 12.5208 5 12.2833 5 12C5 11.7167 5.09583 11.4792 5.2875 11.2875C5.47917 11.0958 5.71667 11 6 11H11V6C11 5.71667 11.0958 5.47917 11.2875 5.2875C11.4792 5.09583 11.7167 5 12 5C12.2833 5 12.5208 5.09583 12.7125 5.2875C12.9042 5.47917 13 5.71667 13 6V11H18C18.2833 11 18.5208 11.0958 18.7125 11.2875C18.9042 11.4792 19 11.7167 19 12C19 12.2833 18.9042 12.5208 18.7125 12.7125C18.5208 12.9042 18.2833 13 18 13H13V18C13 18.2833 12.9042 18.5208 12.7125 18.7125C12.5208 18.9042 12.2833 19 12 19C11.7167 19 11.4792 18.9042 11.2875 18.7125C11.0958 18.5208 11 18.2833 11 18V13Z"
        fill={fill}
      />
    </svg>
  );
}

export function PromptIcon({
  width = 20,
  height = 20,
  opacity = 0.9,
}: IconProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M12 1L14.5 8.5L22 11L14.5 13.5L12 21L9.5 13.5L2 11L9.5 8.5L12 1Z"
        fill="currentColor"
        opacity={opacity}
      />
      <path
        d="M19 3L20 6L23 7L20 8L19 11L18 8L15 7L18 6L19 3Z"
        fill="currentColor"
        opacity="0.7"
      />
    </svg>
  );
}

export function SearchIcon({
  width = 20,
  height = 20,
  fill = 'currentColor',
  className,
}: IconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M16.6915026,16.4744748 L21.3123905,20.5833202 C21.5723511,20.8314966 21.5723511,21.2511527 21.3123905,21.4989261 C21.0624899,21.7385967 20.6729219,21.7449587 20.4123905,21.5166038 L15.4744748,16.6915026 C14.1599843,17.7956707 12.4493806,18.4330969 10.5833202,18.4330969 C7.27214268,18.4330969 4.5,15.7009542 4.5,12.3896921 C4.5,9.07854291 7.27214268,6.34639826 10.5833202,6.34639826 C13.8948894,6.34639826 16.6915026,9.07854291 16.6915026,12.3896921 C16.6915026,14.2557532 16.0540764,15.9663569 15.0499083,17.2808474 Z M10.5833202,7.84371476 C8.10064981,7.84371476 6.06121652,9.88314801 6.06121652,12.3896921 C6.06121652,14.8963362 8.10064981,16.9357695 10.5833202,16.9357695 C13.0660505,16.9357695 15.1054838,14.8963362 15.1054838,12.3896921 C15.1054838,9.88314801 13.0660505,7.84371476 10.5833202,7.84371476 Z"
        fill={fill}
      />
    </svg>
  );
}

export function StarIcon({
  width = 20,
  height = 20,
  fill = 'currentColor',
  className,
}: IconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M12 2L15.09 10.26H23.77L16.84 15.73L19.93 24L12 18.53L4.07 24L7.16 15.73L0.23 10.26H8.91L12 2Z"
        fill={fill}
      />
    </svg>
  );
}

export function BarChartIcon({
  width = 20,
  height = 20,
  fill = 'currentColor',
  className,
}: IconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM9 17H7V7H9V17ZM13 17H11V7H13V17ZM17 17H15V7H17V17Z"
        fill={fill}
      />
    </svg>
  );
}

export function SendIcon({
  width = 24,
  height = 24,
  fill = 'currentColor',
}: IconProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M3.4 20.4L20.85 12.92C21.66 12.57 21.66 11.43 20.85 11.08L3.4 3.6C2.74 3.31 2.01 3.8 2.01 4.51L2 9.12C2 9.62 2.37 10.05 2.87 10.11L17 12L2.87 13.88C2.37 13.95 2 14.38 2 14.88L2.01 19.49C2.01 20.2 2.74 20.69 3.4 20.4Z"
        fill={fill}
      />
    </svg>
  );
}

export function AttachmentIcon({
  width = 20,
  height = 20,
  fill = 'currentColor',
  className,
}: IconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M11 13H6C5.71667 13 5.47917 12.9042 5.2875 12.7125C5.09583 12.5208 5 12.2833 5 12C5 11.7167 5.09583 11.4792 5.2875 11.2875C5.47917 11.0958 5.71667 11 6 11H11V6C11 5.71667 11.0958 5.47917 11.2875 5.2875C11.4792 5.09583 11.7167 5 12 5C12.2833 5 12.5208 5.09583 12.7125 5.2875C12.9042 5.47917 13 5.71667 13 6V11H18C18.2833 11 18.5208 11.0958 18.7125 11.2875C18.9042 11.4792 19 11.7167 19 12C19 12.2833 18.9042 12.5208 18.7125 12.7125C18.5208 12.9042 18.2833 13 18 13H13V18C13 18.2833 12.9042 18.5208 12.7125 18.7125C12.5208 18.9042 12.2833 19 12 19C11.7167 19 11.4792 18.9042 11.2875 18.7125C11.0958 18.5208 11 18.2833 11 18V13Z"
        fill={fill}
      />
    </svg>
  );
}

export function ChevronDownIcon({
  width = 16,
  height = 16,
  fill = 'currentColor',
  className,
}: IconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path d="M7 10L12 15L17 10H7Z" fill={fill} />
    </svg>
  );
}
